/* ============================================================
   CHAOS Ask the Crew — live-chat detection.
   Reveals and wires the "Chat with us" button when a known chat
   widget is present. Silent no-op otherwise.
   ============================================================ */
(function () {
  'use strict';

  // Each provider: detect() returns true when its API is ready; open() opens the widget.
  var providers = [
    { name: 'gorgias',   detect: function () { return !!(window.GorgiasChat && typeof window.GorgiasChat.open === 'function'); },
                         open:   function () { window.GorgiasChat.open(); } },
    { name: 'intercom',  detect: function () { return typeof window.Intercom === 'function'; },
                         open:   function () { window.Intercom('show'); } },
    { name: 'zendesk',   detect: function () { return typeof window.zE === 'function'; },
                         open:   function () { try { window.zE('messenger', 'open'); } catch (e) { try { window.zE('webWidget', 'open'); } catch (e2) {} } } },
    { name: 'tidio',     detect: function () { return !!(window.tidioChatApi && typeof window.tidioChatApi.open === 'function'); },
                         open:   function () { window.tidioChatApi.open(); } },
    { name: 'tawk',      detect: function () { return !!(window.Tawk_API && typeof window.Tawk_API.maximize === 'function'); },
                         open:   function () { window.Tawk_API.maximize(); } },
    { name: 'crisp',     detect: function () { return !!(window.$crisp && typeof window.$crisp.push === 'function'); },
                         open:   function () { window.$crisp.push(['do', 'chat:open']); } },
    { name: 'drift',     detect: function () { return !!(window.drift && window.drift.api && typeof window.drift.api.openChat === 'function'); },
                         open:   function () { window.drift.api.openChat(); } },
    { name: 'livechat',  detect: function () { return !!(window.LiveChatWidget && typeof window.LiveChatWidget.call === 'function'); },
                         open:   function () { window.LiveChatWidget.call('maximize'); } },
    { name: 'hubspot',
      detect: function () {
        return !!window.HubSpotConversations || Array.isArray(window.hsConversationsOnReady);
      },
      open: function () {
        function show() {
          var w = window.HubSpotConversations && window.HubSpotConversations.widget;
          if (!w) return;
          if (typeof w.load === 'function') { try { w.load({ widgetOpen: true }); } catch (e) {} }
          if (typeof w.open === 'function') { try { w.open(); } catch (e) {} }
        }
        if (window.HubSpotConversations && window.HubSpotConversations.widget) {
          show();
        } else {
          window.hsConversationsOnReady = window.hsConversationsOnReady || [];
          window.hsConversationsOnReady.push(show);
        }
      } },
    { name: 'reamaze',   detect: function () { return !!(window._support && window._support.reamaze) || typeof window.$reamaze === 'function'; },
                         open:   function () { if (typeof window.$reamaze === 'function') { window.$reamaze('open'); } else if (window._support && window._support.reamaze && typeof window._support.reamaze.open === 'function') { window._support.reamaze.open(); } } },
    // Shopify Inbox: no public JS API. Detect by the launcher iframe and click it.
    { name: 'shopify-inbox',
      detect: function () {
        return !!document.querySelector('iframe[src*="shopifychat"], iframe[src*="inbox.shopify"], iframe[src*="chat.shopifycdn"], shopify-chat, #shopify-chat');
      },
      open: function () {
        var launcher = document.querySelector('iframe[src*="shopifychat"], iframe[src*="inbox.shopify"], iframe[src*="chat.shopifycdn"]');
        if (!launcher) return;
        // The launcher iframe usually contains the toggle button; clicking the iframe element itself
        // won't forward into it, so fall back to focusing it to nudge visibility.
        try { launcher.focus(); } catch (e) {}
        // Best-effort: many Shopify Inbox installs mount a button on window.
        if (window.Shopify && window.Shopify.Chat && typeof window.Shopify.Chat.show === 'function') {
          window.Shopify.Chat.show();
        }
      } }
  ];

  function findProvider() {
    for (var i = 0; i < providers.length; i++) {
      try {
        if (providers[i].detect()) return providers[i];
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  function wire(button, provider) {
    if (button.dataset.cfAskChatWired === '1') return;
    button.dataset.cfAskChatWired = '1';
    button.hidden = false;
    var scope = button.closest('[data-cf-ask-actions]') || document;
    var contact = scope.querySelector('[data-cf-ask-contact]');
    if (contact) contact.hidden = true;
    button.addEventListener('click', function (evt) {
      evt.preventDefault();
      try { provider.open(); } catch (e) { /* swallow */ }
    });
  }

  function init() {
    var buttons = document.querySelectorAll('[data-cf-ask-chat]');
    if (!buttons.length) return;

    var tries = 0;
    var MAX_TRIES = 40; // ~12s at 300ms

    function tick() {
      var provider = findProvider();
      if (provider) {
        buttons.forEach(function (btn) { wire(btn, provider); });
        return;
      }
      tries++;
      if (tries < MAX_TRIES) {
        setTimeout(tick, 300);
      }
    }

    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
